import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from '../environments/environment';
export function tokenGetter() {
    return localStorage.getItem(environment.localStorage.accessToken);
}
export function getCurrentLocale() {
    return localStorage.getItem(environment.localStorage.language) || 'en';
}
var ɵ0 = function (http) {
    return new TranslateHttpLoader(http, 'assets/i18n/', '-lang.json');
}, ɵ1 = getCurrentLocale();
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0, ɵ1 };
